export interface CredentialsState {
  clientAccessId: string | null;
  jwt: string | null;
}
